export class CompanyClaimRestrictionsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // `skipForbiddenError` is OPT-IN (mirrors getClaims/getRoles): the broker claims editor passes it
  // so a 403 on this optional blacklist degrades to empty instead of page-reloading, while employee
  // callers keep the default forbidden-status reload/re-auth behavior.
  async getRestrictions({ companyId, skipForbiddenError } = {}) {
    return this.#http.get(`/api/companies/${companyId}/claim-restrictions`, {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async updateRestrictions({ companyId, restrictedClaims }) {
    return this.#http.put(`/api/companies/${companyId}/claim-restrictions`, restrictedClaims);
  }
}
